/* eslint-disable no-magic-numbers */
import { useEffect, useState } from 'react';
import { GROUPING_OPTIONS, TableStyle } from '../../../types';
import { rowHeightFromStyles } from '../../../utils-generic';

interface UseRowHeightsParams {
  headerRowStyle: TableStyle;
  normalRowStyle: TableStyle;
  rowStylesPerType: Record<string, TableStyle>;
  selectedForecastsCount: number;
  zoom: number;
  doNotBreak?: boolean;
}

interface RowHeights {
  headerHeight: number;
  rowHeight: number;
  rowHeightByType: Record<string, number>;
}

const ROW_TYPES: GROUPING_OPTIONS[] = [
  GROUPING_OPTIONS.CATEGORIES,
  GROUPING_OPTIONS.GROUPS,
  GROUPING_OPTIONS.ACCOUNTS,
  GROUPING_OPTIONS.ASSUMPTIONS,
  GROUPING_OPTIONS.FORMULAS
];

export const useRowHeights = ({
  headerRowStyle,
  normalRowStyle,
  rowStylesPerType,
  selectedForecastsCount,
  zoom,
  doNotBreak
}: UseRowHeightsParams): RowHeights => {
  const [headerHeight, setHeaderHeight] = useState(
    1.5 * (selectedForecastsCount > 1 ? 2 : 1) * (headerRowStyle.fontSize || 10)
  );
  const [rowHeight, setRowHeight] = useState(1.5 * (normalRowStyle.fontSize || 10));
  const [rowHeightByType, setRowHeightByType] = useState<Record<string, number>>({
    normal: 1.5 * (normalRowStyle.fontSize || 10)
  });

  useEffect(() => {
    if (doNotBreak) {
      return;
    }

    let stroke = Math.round(headerRowStyle.strokeWidth || 1);
    setHeaderHeight(
      zoom *
        rowHeightFromStyles(headerRowStyle.fontSize || 10, headerRowStyle.strokePosition, stroke) *
        (selectedForecastsCount > 1 ? 2 : 1)
    );

    stroke = Math.round(normalRowStyle.strokeWidth || 1);
    const normalRowH = rowHeightFromStyles(normalRowStyle.fontSize || 10, normalRowStyle.strokePosition, stroke);
    setRowHeight(zoom * normalRowH);

    const rowHeights: Record<string, number> = {};
    ROW_TYPES.forEach(type => {
      const customRowStyle = rowStylesPerType[type];
      let height = normalRowH;
      if (customRowStyle) {
        stroke = Math.round(customRowStyle.strokeWidth || normalRowStyle.strokeWidth || 1);
        height = rowHeightFromStyles(
          customRowStyle.fontSize || normalRowStyle.fontSize || 10,
          customRowStyle.strokePosition,
          stroke
        );
      }
      rowHeights[type] = height * zoom;
    });
    setRowHeightByType(rowHeights);
  }, [headerRowStyle, normalRowStyle, rowStylesPerType, doNotBreak, selectedForecastsCount, zoom]);

  return { headerHeight, rowHeight, rowHeightByType };
};
